// Supabase-Zugang für das Anfrageformular.
// Der anon key ist für den Browser bestimmt und darf öffentlich sein — er erlaubt
// nur den Aufruf der Edge Function. Geschrieben wird ausschliesslich serverseitig
// mit der service_role, die den Browser nie erreicht.

export const SUPABASE_URL = 'https://db.alitero.eu';

export const SUPABASE_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlzcyI6InN1cGFiYXNlIiwiaWF0IjoxNzgyNTgzNTUwLCJleHAiOjE5NDAyNjM1NTB9.US8U3FledklcPOjCm5WTRLd2CTi5PqTq-hS9L37kPUA';

export const SEND_REQUEST_URL = `${SUPABASE_URL}/functions/v1/send-request`;
